import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-products-bg",
  "use": "icon-products-bg-usage",
  "viewBox": "0 0 258 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 258 36\" id=\"icon-products-bg\">\n<style type=\"text/css\">\n\t#icon-products-bg .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#005BAC;}\n\t#icon-products-bg .st1{opacity:0.3975;fill-rule:evenodd;clip-rule:evenodd;fill:#005BAC;enable-background:new    ;}\n\t#icon-products-bg .st2{opacity:0.156;fill-rule:evenodd;clip-rule:evenodd;fill:#005BAC;enable-background:new    ;}\n</style>\n<polygon id=\"icon-products-bg_矩形\" class=\"st0\" points=\"20,0 8,0 0,36 12,36 \" />\n<polygon id=\"icon-products-bg_矩形备份-11\" class=\"st1\" points=\"35,0 23,0 15,36 27,36 \" />\n<polygon id=\"icon-products-bg_矩形备份-12\" class=\"st2\" points=\"257.2,0 38,0 30,36 249.2,36 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/products-bg.svg
// module id = lV6p
// module chunks = 2